//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zbParser from '@/components/FormGenerator/components/parser/ZBParser';
import { configSaveForm, configInfo } from '@/api/systemConfig.js';
import { Debounce } from '@/utils/validate';
export default {
  name: 'integralconfig',
  components: {
    zbParser: zbParser
  },
  data: function data() {
    return {
      isShow: false,
      isCreate: 0,
      editData: {},
      formId: 109
    };
  },
  mounted: function mounted() {
    this.getFormInfo();
  },
  methods: {
    resetForm: function resetForm(formValue) {
      this.editData = {};
    },
    handlerSubmit: Debounce(function (data) {
      var _this = this;
      var tempArr = [];
      for (var key in data) {
        var obj = {};
        obj.name = key;
        obj.title = key;
        obj.value = data[key];
        tempArr.push(obj);
      }
      var _pram = {
        fields: tempArr,
        id: this.formId,
        sort: 0,
        status: true
      };
      configSaveForm(_pram).then(function (res) {
        _this.getFormInfo();
        _this.$message.success('操作成功');
      });
    }),
    // 获取表单详情
    getFormInfo: function getFormInfo() {
      var _this2 = this;
      configInfo({
        id: this.formId
      }).then(function (res) {
        _this2.isShow = false;
        _this2.editData = res;
        _this2.isCreate = 1;
        setTimeout(function () {
          // 让表单重复渲染待编辑数据
          _this2.isShow = true;
        }, 80);
      });
    }
  }
};